import { useUserDetailCardQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  apiFileId: string;
  url: string;
}

export function useQuery(id: string) {
  const tuple = useUserDetailCardQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        apiFileId: tuple.data?.person?.profilePicture?.id ?? '',
        url: tuple.data?.person?.profilePicture?.url ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
